import { DefaultInvoice } from '@/store/modules/checkout/defaultValues'

export function state (storeCheckout) {
  storeCheckout.state.shipToStore = false
  storeCheckout.state.shipStoreId = ''
  storeCheckout.state.invoice = { ...DefaultInvoice }
  return storeCheckout.state
}
